// The Réhaut Ring — the house radial language (FLAGSHIPS Bet 3): ONE
// component for the three circular facts — 24h window, package balance,
// nota completeness. Ported from ui_kits/rehaut-flagships/flagship-primitives.jsx.
import type { ReactNode } from 'react';

export type RingTone = 'accent' | 'error' | 'warn' | 'ok' | 'neutral';

const RING_COLOR: Record<RingTone, string> = {
  accent: 'var(--accent)',
  error: 'var(--error-ink)',
  warn: 'var(--warn-ink)',
  ok: 'var(--ok-ink)',
  neutral: 'var(--ink-4)',
};

export function Ring({
  frac,
  size = 44,
  tone = 'accent',
  thickness = 2,
  children,
  title,
}: {
  /** 0..1 fill fraction (clamped). */
  frac: number;
  size?: number;
  tone?: RingTone;
  thickness?: number;
  children?: ReactNode;
  title?: string;
}) {
  const r = size / 2 - thickness - 1;
  const c = 2 * Math.PI * r;
  const filled = c * Math.max(0, Math.min(1, frac));
  return (
    <span
      title={title}
      style={{
        position: 'relative', width: size, height: size, flexShrink: 0,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <svg width={size} height={size}
        style={{ position: 'absolute', inset: 0, transform: 'rotate(-90deg)' }} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke="var(--hairline-strong)" strokeWidth={thickness} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke={RING_COLOR[tone]} strokeWidth={thickness}
          strokeDasharray={`${filled} ${c}`} strokeLinecap="round" />
      </svg>
      <span style={{ position: 'relative', textAlign: 'center', lineHeight: 1 }}>{children}</span>
    </span>
  );
}
